import { render, staticRenderFns } from "./TheActivities.vue?vue&type=template&id=78c672c4&scoped=true&"
import script from "./TheActivities.vue?vue&type=script&lang=js&"
export * from "./TheActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c672c4",
  null
  
)

export default component.exports